module.exports = __webpack_public_path__ + "static/img/logo6.3ca88ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Menu/logo6.svg
// module id = hVBf
// module chunks = 0